import _ from "lodash";
import { TICKET_TYPE } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        ticketType: _.cloneDeep(constants.TICKET_TYPE_INPUT)
    }
}

const TicketTypeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TICKET_TYPE.SET_TICKET_TYPE_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case TICKET_TYPE.SET_TICKET_TYPE:
        case TICKET_TYPE.SET_TICKET_TYPE_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    ticketType: action.ticketType
                }
            })
        default:
            return state
    }
}

export default TicketTypeReducer